import React from 'react';

// @ts-ignore
import Icon from 'assets/images/traps/SRBM.svg';

interface IconProps {
  height?: number;
  width?: number;
}

const SmartRodentBaitModuleIcon: React.FC<IconProps> = ({ height = 50, width = 50 }) => {
  return <img src={Icon} height={height} width={width} alt="Smart Rodent Bait Module Icon" />;
};

export default SmartRodentBaitModuleIcon;
